export default "__VITE_ASSET__tGXNQ0Xy__"